export const AIRLINE_CODES = {
  United: "UA",
  "American Airlines": "AA",
  "Alaska Airlines": "AS",
  "Southwest Airlines": "WN",
  jetBlue: "B6",
  "Spirit Airlines": "NK",
  "Delta Airlines": "DL",
  "Allegiant Air": "G4",
  "Frontier Airlines": "F9",
  "Silver Airways": "3M",
  "Hawaiian Airlines": "HA",
  "Sun Country Airlines": "SY",
  "Cape Air": "9K",
  "Aegean Airlines": "A3",
  "Air Canada": "AC",
  "Azul Airlines": "AD",
  "Air france": "AF",
  Aeromexico: "AM",
  "Aerolineas Argentinas": "AR",
  Avianca: "AV",
  Finnair: "AY",
  Alitalia: "AZ",
  "British Airways": "BA",
  "Eva Airways": "BR",
  "Air China": "CA",
  Copa: "CM",
  "Cathay Pacific": "CX",
  "Aer Lingus": "EI",
  Emirates: "EK",
  "Ethiopian Airlines": "ET",
  Icelandair: "FI",
  Iberia: "IB",
  "JAL Japan Airlines": "JL",
  "Korean Air": "KE",
  "KLM Royal Dutch Airlines": "KL",
  "LAN Airlines": "LA",
  Lufthansa: "LH",
  "Swiss Int'l Air Lines": "LX",
  "Malaysia Airlines": "MH",
  ANA: "NH",
  "Air New Zealand": "NZ",
  "Austrian Airlines": "OS",
  "Latam Airlines": "PZ",
  Qantas: "QF",
  SAS: "SK",
  "Singapore Airlines": "SQ",
  "Turkish Airlines": "TK",
  "TAP Air Portugal": "TP",
  "Air Transat": "TS",
  "Virgin Australia": "VA",
  "Virgin Atlantic": "VS",
  "Vueling Airlines": "VY",
  WestJet: "WS",
};

export const AIRLINE_CONTACT_EMAILS = {
  UA: "gpelite@united.com",
  AA: "aagmt.topaccounts@aa.com",
  AS: "group.desk@alaskaair.com",
  WN: "goswa@wnco.com",
  B6: "", // Unknown
  NK: "", // Unknown
  DL: "leisurepremium@delta.com",
  G4: "", // Unknown
  F9: "", // Unknown
  "3M": "", // Unknown
  HA: "", // Unknown
  SY: "", // Unknown
  "9K": "", // Unknown
  A3: "", // Unknown
  AC: "", // Unknown
  AD: "", // Unknown
  AF: "", // Unknown
  AM: "", // Unknown
  AR: "", // Unknown
  AV: "", // Unknown
  AY: "", // Unknown
  AZ: "", // Unknown
  BA: "", // Unknown
  BR: "", // Unknown
  CA: "", // Unknown
  CM: "", // Unknown
  CX: "", // Unknown
  EI: "", // Unknown
  EK: "", // Unknown
  ET: "", // Unknown
  FI: "", // Unknown
  IB: "", // Unknown
  JL: "", // Unknown
  KE: "", // Unknown
  KL: "", // Unknown
  LA: "", // Unknown
  LH: "", // Unknown
  LX: "", // Unknown
  MH: "", // Unknown
  NH: "", // Unknown
  NZ: "", // Unknown
  OS: "", // Unknown
  PZ: "", // Unknown
  QF: "", // Unknown
  SK: "", // Unknown
  SQ: "", // Unknown
  TK: "", // Unknown
  TP: "", // Unknown
  TS: "", // Unknown
  VA: "", // Unknown
  VS: "", // Unknown
  VY: "", // Unknown
  WS: "", // Unknown
};
